import watchEasyToken from './easyToken'

export default watchEasyToken
